import React from "react";
import { observer } from "mobx-react";
import { CreditPurchaseViewStore } from "../../store";
import { MyCreditPurchasesViewForm } from "./MyCreditPurchasesViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type MyCreditPurchasesViewProps = {
  creditPurchaseViewStore: CreditPurchaseViewStore;
};

export const MyCreditPurchasesView: React.FC<MyCreditPurchasesViewProps> =
  observer(({ creditPurchaseViewStore }) => {
    return (
      <div>
        <MyCreditPurchasesViewForm
          creditPurchaseViewStore={creditPurchaseViewStore}
          quantity={creditPurchaseViewStore.quantityValue}
          purchaseDate={creditPurchaseViewStore.purchaseDateValue}
          expirationDate={creditPurchaseViewStore.expirationDateValue}
          unitPrice={creditPurchaseViewStore.unitPriceValue}
          notes={creditPurchaseViewStore.notesValue}
          onPrint={(handlePrint: () => void) =>
            creditPurchaseViewStore.printCreditPurchase(handlePrint)
          }
          onCancel={() => creditPurchaseViewStore.cancelCreditPurchase()}
          onEdit={
            creditPurchaseViewStore.isEditEnabled
              ? () => creditPurchaseViewStore.editCreditPurchase()
              : undefined
          }
        />
        <ErrorDialog
          open={creditPurchaseViewStore.errorDialogOpened}
          title={creditPurchaseViewStore.errorTitle}
          description={creditPurchaseViewStore.errorDescription}
          onClose={() => creditPurchaseViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
